import type { TransactionReceipt } from 'web3-core';
import { Comptroller } from 'types/contracts';
import { checkForComptrollerTransactionError } from 'errors';

export interface IExitMarketInput {
  comptrollerContract: Comptroller;
  accountAddress?: string;
  brtokenAddress: string;
}

export type ExitMarketOutput = TransactionReceipt;

const exitMarket = async ({
  comptrollerContract,
  accountAddress,
  brtokenAddress,
}: IExitMarketInput): Promise<ExitMarketOutput> => {
  const resp = await comptrollerContract.methods
    .exitMarket(brtokenAddress)
    .send({ from: accountAddress });
  return checkForComptrollerTransactionError(resp);
};

export default exitMarket;
